<template>
  <el-main>
    <el-row type="flex">
      <el-col v-if="!classUploaded && !classImported" :xs="24" :sm="{span: 20, offset: 4}">
        <base-invite
          :title="$t($i18nLabelsHelper(currentOrganizationType, 'add_to_group'))"
          v-on="$listeners"
          :handleSuccessButtonClick="handleInviteClick"
          :backToUsers="backToUsers"
          :successButtonLabel="$t('common.import')"
          :canSubmit="form.fileReady"
          :primaryLoading="primaryLoading"
        >
          <template v-slot:invite-header>
            <h3>{{$t($i18nLabelsHelper(currentOrganizationType, 'import_groups'))}}</h3>
          </template>
          <template v-slot:invite-body>
            <el-form :rules="rules" :model="form" ref="import">
              <el-form-item class="uploader" name="fileList">
                <div class="upload-instructions">
                  <p>{{$t('organizations.invite_users.import.instructions2')}}</p>
                  <a
                    href="/files/ELSA-Classlist.xlsx"
                    download
                  >{{$t('organizations.invite_users.import.get_template_xlsx')}}</a>
                  <!-- <p>{{$t('common.or')}}</p>
                  <a
                    href="/files/ELSA-Classlist.csv"
                    download
                  >{{$t('organizations.invite_users.import.get_template_csv')}}</a>-->
                  <p :style="{'margin-left': '0px'}">,</p>
                  <p
                    :style="{'margin-left': '0px'}"
                  >{{$t('organizations.invite_users.import.instructions3')}}</p>
                </div>

                <el-upload
                  v-loading="loading"
                  class="upload-files"
                  :action="actionUrl"
                  :before-upload="getActionUrl"
                  :http-request="submitFile"
                  :on-success="onSuccess"
                  v-bind:class="{'hide-uploader': hideUploader, 'hide-file-list': hideFileList }"
                  :drag="true"
                  :file-list="form.fileList"
                  :show-file-list="true"
                  :auto-upload="true"
                  :on-change="updateFileList"
                  :limit="1"
                  :on-remove="updateFileList"
                >
                  <i class="elsa-icon-import-grey"></i>
                  <div class="el-upload__text">
                    {{$t('organizations.invite_users.import.instructions')}}
                    <p>{{$t('common.or')}}</p>
                    <chip icon>{{$t('organizations.invite_users.import.browse_files')}}</chip>
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>
        </base-invite>
      </el-col>
      <el-col v-if="classUploaded && !classImported" :xs="24" :sm="{span: 20, offset: 4}" class="class-overview">
        <h1 class="title">{{ $t($i18nLabelsHelper(currentOrganizationType, 'add_to_group')) }}</h1>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
        <el-tabs type="card" :stretch="true">
          <!-- <el-tabs type="card"> -->
          <el-tab-pane
            v-for="(classObject, idx) in classesObjects"
            :key="idx"
            :label="classObject.className"
            :name="`${idx}`"
          >
            <elsa-section :title="$t($i18nLabelsHelper(currentOrganizationType, 'group_overview'))">
              <template v-slot:body>
                <create-class-overview
                  :classDetails="classObject"
                  :showEditClass="false"
                  :showUserInfo="false"
                  :organizationType="currentOrganizationType"
                  :organizationId="organizationId"
                />
              </template>
            </elsa-section>
            <elsa-section>
              <template v-slot:body>
                <create-class-goals
                  :goals.sync="classObject.goals"
                  :organizationType="currentOrganizationType"
                  :readOnly="true"
                />
              </template>
            </elsa-section>
          </el-tab-pane>
        </el-tabs>

        <div>
          <primary-button
            @click.native="createClass"
            v-loading="primaryLoading"
          >{{ $t('classes.create_class_flow.class_created.goals_section.next') }}</primary-button>
          <tertiary-button
            @click.native="backToUsers"
          >{{ $t('classes.create_class_flow.class_created.goals_section.will_do_this_later') }}</tertiary-button>
        </div>
      </el-col>
      <el-col v-if="classImported" :xs="24" :sm="{span: 20, offset: 4}">
        <h1 class="title">{{ $t($i18nLabelsHelper(currentOrganizationType, 'import_class_success_title'), {numberClassesImported}) }}</h1>
        <div class="main">
          <div class="inner">
            <tertiary-button
              @click.native="goToImportUser"
            >{{ $t($i18nLabelsHelper(currentOrganizationType, 'classes.import_users')) }}</tertiary-button>
            <tertiary-button
              @click.native="backToUsers"
            >{{ $t('classes.create_class_flow.class_created.goals_section.will_do_this_later') }}</tertiary-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
import ElsaSection from "@/components/common/ElsaSection";
import Chip from "@/components/common/Chip";
import BaseInvite from "@/components/organizations/invites/BaseInvite";
import ClassGoals from "@/components/classes/create-classes/ClassGoals";
import CreateClassOverview from "@/components/classes/create-classes/CreateClassOverview";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";
import CreateClassGoals from "@/components/classes/create-classes/CreateClassGoals";
import { warningMessage, successMessage } from "../../utils/messages";
import { includes, map } from "ramda";
import { uploadFile, readFile } from "../../utils/uploader";
import { mapActions, mapGetters, mapState } from "vuex";

const allowedTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
];

export default {
  components: {
    Chip,
    BaseInvite,
    CreateClassOverview,
    CreateClassGoals,
    PrimaryButton,
    TertiaryButton,
    ElsaSection
  },
  props: ["organizationId"],
  data() {
    return {
      classUploaded: false,
      classImported: false,
      errors: null,
      canSubmit: false,
      actionUrl: "",
      loading: false,
      primaryLoading: false,
      uploadId: "",
      form: {
        fileList: [],
        fileReady: false
      },
      rules: {
        fileList: [
          {
            required: true
          }
        ]
      },
    };
  },
  computed: {
    classesObjects() {
      return this.importClassesPreview;
    },
    numberClassesImported(){
      return this.classesObjects.length;
    },
    hideUploader() {
      return this.form.fileList.length > 0;
    },
    hideFileList() {
      return this.form.fileList.length === 0;
    },
    editClass() {
      return () => {};
    },
    ...mapState("classes", ["importClassesPreview"]),
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      currentUser: "user/getUser"
    })
  },
  methods: {
    async getActionUrl(file) {
      this.loading = true;
      this.errors = false;
      const fileSize = file.size;
      const contentType = file.type;
      const organizationId = this.organizationId;
      const fileName = file.name;
      const payload = {
        fileSize,
        contentType,
        organizationId,
        fileName
      };

      if (!includes(contentType, allowedTypes)) {
        this.errors = true;
        this.updateFileList(null, []);
        this.loading = false;
        warningMessage(this.$t("common.file_type_not_allowed"))(this);
        return Promise.reject(false);
      }

      try {
        const req = await this.getImportClassesUploadUrl({
          ...payload
        });

        this.actionUrl = req.data.presigned_url;
        this.uploadId = req.data.callback_id;
      } catch (e) {
        // show warning
        // please try again
        this.errors = true;
        this.updateFileList(null, []);
        this.loading = false;
        warningMessage(this.$t("common.generic_error_message"))(this);
        return Promise.reject(false);
      }
    },
    async submitFile(request) {
      try {
        const { action: url, file } = request;
        const rawFile = await readFile(file);

        return await uploadFile(url, file.type, rawFile);
      } catch (e) {
        this.errors = true;
        this.loading = false;

        return warningMessage(this.$t("common.generic_error_message"))(this);
      }
    },
    async onSuccess(response, file, fileList) {
      this.loading = false;
      this.form.fileReady = true;
      try {
        return await this.getImportClassesPreview({
          organizationId: this.organizationId,
          callbackId: this.uploadId
        });
      } catch (e) {
        this.form.fileReady = false;
        return warningMessage(this.$t("common.error_duplidate_group_name"))(this);
      }
    },
    async handleInviteClick() {
      this.classUploaded = true;
      this.uploadFile = true;
      this.primaryLoading = false;
    },
    async createClass() {
      try {
        this.primaryLoading = true;
        await this.postImportClassCallback({
          organizationId: this.organizationId,
          callbackId: this.uploadId
        });
        this.classImported = true;
        successMessage(
          this.$t(
            this.$i18nLabelsHelper(
              this.currentOrganizationType,
              "import_groups_success"
            )
          )
        )(this);
      } catch (e) {
        return warningMessage(this.$t("common.generic_error_message"))(this);
      } finally {
        this.primaryLoading = false;
      }
    },
    backToUsers() {
      return this.$router.push({
        name: "classes",
        params: {
          organizationId: this.organizationId
        }
      });
    },
    goToImportUser() {
      return this.$router.push({
        name: 'import-users',
        params: { organizationId: this.organizationId }
      });
    },
    updateFileList(file, fileList) {
      this.form.fileList = fileList;
    },
    ...mapActions("classes", [
      "getImportClassesUploadUrl",
      "postImportClassCallback",
      "getImportClassesPreview"
    ]),
    ...mapActions("invite", ["postSentInviteUploadEmails"])
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

::v-deep .invite h1,
.class-overview h1.title {
  color: $blue;
  font-weight: 800;
  font-size: 22px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin: 0;
  text-align: initial;
  border: 0;
}

.class-overview h1.title {
  padding-bottom: 32px;
}

.class-overview ::v-deep .elsa-section:first-of-type {
  padding-bottom: 0px;
}

::v-deep .el-tabs__item {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  // text-align: center;
  text-transform: capitalize;
  color: $darker-blue;

  vertical-align: middle;

  &.is-active {
    background-color: white;
  }
}

::v-deep .el-tabs__nav-wrap {
  // background-color: white;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}
</style>
